// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__8pnOz","icon":"styles_icon__f5Ipb","title":"styles_title__cPb0s","text":"styles_text__aTJ8m"};